<script>

    import {onMount} from "svelte";
    import {toasts} from "svelte-toasts";
    import {decode} from "html-entities";

    export let model_root;
    export let cid;
    export let answerToComment;
    export let reloadComments;

    let comment = {
        author: "",
        content: "",
        official: 1,
        published: 1,
    }

    onMount(() => {
        getCurrentUser();
    })

    const getCurrentUser = () => {
        return fetch(model_root + 'admin/user_management/get_current_user.php', {
            method: "GET"
        })
            .then(response => response.json())
            .then(user => {
                comment.author = decode(`${user.uprename} ${user.uname}`);
            })
    }

    function submitComment() {
        let answer_to = answerToComment.id;
        if (answer_to === null) {
            answer_to = -1;
        }
        const data = new FormData();
        data.append("content_id", cid);
        data.append("author", comment.author);
        data.append("content", comment.content);
        data.append("answer_to", answer_to);
        data.append("official", comment.official);
        data.append("published", comment.published);

        return new Promise((resolve, reject) => {
            fetch(model_root + 'shared/contents/comments/submit_comment.php', {
                method: "POST",
                body: data
            })
                .then(response => response.text())
                .then(msg => {
                    if (msg === "success") {
                        reloadComments();
                        cancelAnswering(); // reset the answer-to mode
                    } else {
                        toasts.error('Falscher Wert für ein Kommentarfeld', msg, {duration: 10000});
                    }
                });
        });

    }

    const cancelAnswering = () => {
        answerToComment.id = null;
        answerToComment.preview = "";
    }

</script>

<hr>
<div class="bg-light p-3 rounded" id="write-comment">
    <h6>Kommentar verfassen</h6>
    {#if answerToComment.id !== null}
        <div class="border-top border-bottom py-2 my-3">
            <p class="mb-1">Sie antworten auf einen Kommentar:</p>
            <p class="mb-1"><i>"{answerToComment.preview}"</i></p>
            <button class="btn-sm btn-secondary" on:click={cancelAnswering}><i class="fas fa-ban"></i> Abbrechen</button>
        </div>
    {/if}
    <div class="mt-3">
        <input class="form-control" bind:value={comment.author} placeholder="Name">
        <textarea maxlength="1000" rows="4" class="form-control" bind:value={comment.content}
                  placeholder="Kommentar"></textarea>
        <button class="btn btn-primary w-auto" on:click={submitComment}><i class="fas fa-paper-plane me-1"></i> Kommentar veröffentlichen</button>
    </div>
</div>
